var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"clrbtn btn-tskr btn-success",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.accept($event)}}},[_vm._v("Accept this offer")])}
var staticRenderFns = []

export { render, staticRenderFns }